import React from "react";
// import degreeImg from "../assets/be-degree-pic.png";
import useScrollAnimation from "../components/useScrollAnimation";


const educationData = [
    {
        date: "2021 - 2025",
        degree: "Bachelor of Engineering (Computer Engineering)",
        institute: "Vidyavardhini’s College of Engineering & Technology (VCET)",
        university: "Mumbai University",
        score: "CGPA: 8.9",
        // image: degreeImg, // 👈 image added here
        details: [
            "Studied core computer engineering subjects including DBMS, OS, CN, and DSA",
            "Completed multiple academic and practical projects",
            "Actively participated in technical workshops and seminars",
            "Honorse in AIML",
        ],
        projects: [
            // {
            //     name: "Jal Jeevan ",
            //     description:
            //         "Machine learning based system to predict lung cancer using user symptoms.",
            //     techStack: ["Python", "SVM", "Machine Learning"],
            //     points: [
            //         "Implemented SVM model for prediction",
            //         "Designed user input system for symptom selection",
            //         "Evaluated model accuracy using test datasets",
            //     ],
            // },
        ],
        // certificate: "link",
    },
    {
        date: "2018 - 2021",
        degree: "Diploma in Computer Engineering",
        institute: "MSBTE",
        university: "Maharashtra State Board of Technical Education",
        score: "Percentage: 96%",
        details: [
            "Strong foundation in programming, databases, and web technologies",
            "Completed diploma with distinction",
        ],
        projects: [
            // {
            //     name: "Python MCQ Quiz System",
            //     description:
            //         "Machine learning based system to predict lung cancer using user symptoms.",
            //     techStack: ["Python", "SVM", "Machine Learning"],
            //     points: [
            //         "Implemented SVM model for prediction",
            //         "Designed user input system for symptom selection",
            //         "Evaluated model accuracy using test datasets",
            //     ],
            // },
        ],
        // certificate: "link",
    },
    {
        date: "2017 - 2018",
        degree: "Secondary School Certificate (SSC)",
        institute: "Maharashtra State Board",
        university: "Maharashtra State Board of Secondary and Higher Secondary Education",
        score: "Percentage: 84%",
        details: [
            "Built a strong academic foundation in mathematics, science, and logical reasoning",
            "Demonstrated consistent academic performance with a solid percentage",
        ],
        projects: [],
        // certificate: "link",
    }

];

export default function Education() {
  return (
    <div className="container mt-5 pt-5">
      <h2 className="fw-bold mb-5">Education</h2>

      <div className="timeline">
        {educationData.map((edu, index) => (
          <EducationItem index={index} key={index} edu={edu} />
        ))}
      </div>
    </div>
  );
}


function EducationItem({ edu , index }) {
  const ref = useScrollAnimation();
  const shouldAnimate = index > 1; 
  return (
    <div ref={shouldAnimate ? ref : null}  className={`timeline-item mb-5 ${shouldAnimate ? "scroll-hidden" : ""}`}>
      <div className="timeline-dot"></div>

      <div className="timeline-content card p-4">
        <div className="row align-items-center">

          {/* LEFT SIDE - TEXT */}
          <div className={edu.image ? "col-md-8" : "col-12"}>
            <span className="small">{edu.date}</span>
            <h5 className="mt-2">{edu.degree}</h5>
            <p className="mb-1">{edu.institute}</p>
            <p className="mb-1">{edu.university}</p>
            <p className="fw-semibold">{edu.score}</p>

            <ul className="mt-3">
              {edu.details.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            {edu.certificate && (
              <div className="mt-3">
                <a
                  href={edu.certificate}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-light btn-sm"
                >
                  View Certificate
                </a>
              </div>
            )}

            {edu.projects && edu.projects.length > 0 && (
              <div className="mt-4">
                <hr />
                <h6 className="fw-semibold mb-2">Academic Projects</h6>

                {edu.projects.map((project, pIndex) => (
                  <div key={pIndex} className="mb-3">
                    <p className="mb-1 fw-semibold">{project.name}</p>
                    <p className="mb-1 small">{project.description}</p>
                    <p className="mb-1 small">
                      <strong>Tech:</strong> {project.techStack.join(", ")}
                    </p>

                    <ul className="small mt-2">
                      {project.points.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* RIGHT SIDE - IMAGE */}
          {edu.image && (
            <div className="col-md-4 text-center mt-3 mt-md-0">
              <img
                src={edu.image}
                alt="Education"
                className="img-fluid rounded education-img"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
